import {
    ISystemState,
    SystemActionTypes,
    START_FETCHING,
    STOP_FETCHING,
    TOGGLE_ERROR_MODAL,
    TOGGLE_SUCCESS_MODAL,
    TOGGLE_SIDEBAR,
} from './types';

export const systemInitialState: ISystemState = {
    userName: null,
    isFetching: false,
    loggedIn: false,
    isErrorModalVisible: false,
    isSuccessModalVisible: false,
    systemModalContent: {
        title: '',
        content: '',
    },
    sidebar: undefined,
};

export function systemReducer(state = systemInitialState, action: SystemActionTypes): ISystemState {
    switch (action.type) {
        case START_FETCHING:
            return { ...state, isFetching: true };
        case STOP_FETCHING:
            return {
                ...state,
                isFetching: false,
            };
        case TOGGLE_ERROR_MODAL:
            return {
                ...state,
                isErrorModalVisible: !state.isErrorModalVisible,
                systemModalContent: {
                    title: action.payload.title,
                    content: action.payload.content,
                },
            };

        case TOGGLE_SUCCESS_MODAL:
            return {
                ...state,
                isSuccessModalVisible: !state.isSuccessModalVisible,
                systemModalContent: {
                    title: action.payload.title,
                    content: action.payload.content,
                },
            };
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                sidebar: action.payload.sidebar,
            };
        default:
            return state;
    }
}
